
// ISOTOPE FILTER
jQuery(document).ready(function($){

  if ( $('.iso-box-wrapper').length > 0 ) { 

      var $container  = $('.iso-box-wrapper'), 
        $imgs     = $('.iso-box img');

      // $container.imagesLoaded(function () {
      //
      //   $container.isotope({
      //   layoutMode: 'fitRows',
      //   itemSelector: '.iso-box'
      //   });
      //
      //   $imgs.load(function(){
      //     $container.isotope('reLayout');
      //   })
      //
      // });

      //filter items on button click

      $('.filter-wrapper li a').click(function(){

          var $this = $(this), filterValue = $this.attr('data-filter');

      // $container.isotope({
      //   filter: filterValue,
      //   animationOptions: {
      //       duration: 750,
      //       easing: 'linear',
      //       queue: false,
      //   }
      // });

      // don't proceed if already selected 

      if ( $this.hasClass('selected') ) { 
        return false; 
      }

      var filter_wrapper = $this.closest('.filter-wrapper');
      filter_wrapper.find('.selected').removeClass('selected');
      $this.addClass('selected');

        return false;
      }); 

  }

});


// PRELOADER JS
$(window).on('load', function(){
    $('.preloader').fadeOut(1000); // set duration in brackets    
});

// HOME BACKGROUND SLIDESHOW
// $(function(){
//     jQuery(document).ready(function() {
//         $('#home').backstretch([
//             "assets/baseball-bat-ball.jpg",
//             "assets/ballimage.jpg",
//             // "http://localhost:3000/assets/about-img-12f67bf61f4ad44413f3ce8fc831683052beb94a5690a97e365ebd8b6c72f52e.jpg",
//             // "http://localhost:3000/assets/about-img-12f67bf61f4ad44413f3ce8fc831683052beb94a5690a97e365ebd8b6c72f52e.jpg",
//         ],  {duration: 2000, fade: 750});
//     });
// })

// jQuery to collapse the navbar on scroll //
$(window).scroll(function() {
    if ($(".navbar").offset().top > 50) {
        $(".navbar-fixed-top").addClass("top-nav-collapse");
    } else {
        $(".navbar-fixed-top").removeClass("top-nav-collapse");
    }
});


/* HTML document is loaded. DOM is ready. 
-------------------------------------------*/
$(function(){

  // ------- WOW ANIMATED ------ //
  wow = new WOW(
  {
    mobile: false
  });
  wow.init();


  // HIDE MOBILE MENU AFTER CLIKING ON A LINK
  $('.navbar-collapse a').click(function(){
        $(".navbar-collapse").collapse('hide');
    });


  // NIVO LIGHTBOX
  $('.iso-box-section a').nivoLightbox({
        effect: 'fadeScale',
    });



});

